import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import useSWR from "swr";
import { PATH } from "../../constants/constants";
import { useLocation } from "react-router-dom";

const StyledContainer = styled.div<{ hero: string }>`
  display: flex;
  min-height: 10rem;
  align-items: center;
  margin: 0 auto;
  position: relative;
  padding-bottom: 0;
  background-size: contain;
  background-position: 50% 100%;
  background-repeat: no-repeat;
  & > div {
    width: 100%;
  }
  @media screen and (min-width: 430px) {
    min-height: 15rem;
    max-width: 600px;
  }
  @media screen and (min-width: 768px) {
    min-height: 20rem;
    max-width: 100%;
  }
  ${(props) => ` background-image: url(${props.hero})`}
`;

const StyledHeader = styled.h1`
  font-weight: 600;
  font-size: 1.5rem;
  overflow: hidden;
  text-align: center;
  @media screen and (max-width: 420px) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 360px) {
    font-size: 1rem;
  }
`;

const fallBackTagLine = "";

/**
 * Math.floor(Math.random() * (max - min + 1)) + min;
 */
const getRandom = (max: number, min: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const Hero = () => {
  const [imagepath, setImagePath] = useState("");
  const { data, error } = useSWR("taglines.json", {
    revalidateOnFocus: false,
    errorRetryCount: 10,
  });
  const location = useLocation();
  useEffect(() => {
    const loadImage = () => {
      const heroIndex = getRandom(144, 1);
      const imagePath = `${PATH.images}/hero/${heroIndex}.svg`;
      const image = new Image();
      image.src = imagePath;
      image.onload = () => {
        setImagePath(imagePath);
      };
    };

    loadImage();
  }, [location]);
  const tagLines = data?.taglines;
  return (
    <div>
      <StyledContainer hero={imagepath}></StyledContainer>
      <div>
        <StyledHeader>
          {imagepath && tagLines && tagLines.length > 0 && !error
            ? tagLines[getRandom(tagLines.length - 1, 0)]
            : fallBackTagLine}
        </StyledHeader>
      </div>
    </div>
  );
};
